import {
  formatCompactNumber,
  resolveLocale,
} from "echart-table-library";

/** Number formatters shared by widgets and business callbacks (section 34).
 *  All helpers take a BCP 47 locale tag (defaults to `en-US`) so separators
 *  and compact magnitudes follow the app's language (shared/i18n): `en-US`
 *  groups with `,` and decimals with `.`, `ja-JP` and `fr-FR` use their own
 *  `Intl` rules (`fr` → comma decimal + space grouping; compact lengths
 *  render `275M` / `2.75億` / `275 M` respectively). */

/** Compact length formatting via the library's locale-aware `Intl` wrapper:
 *  275000000 → "275M" (en) / "2.75億" (ja) / "275 M" (fr). */
export function formatCompactLength(value: number, locale?: string): string {
  if (!Number.isFinite(value)) return "—";
  return formatCompactNumber(value, resolveLocale(locale));
}

/** Locale grouping for whole counts: 41200 → "41,200" (en) / "41 200" (fr). */
export function formatCount(value: number, locale = "en-US"): string {
  return Number.isFinite(value)
    ? new Intl.NumberFormat(locale).format(value)
    : "—";
}

/** Fixed-inch label: 18.27 → "18.27", 18 → "18". */
export function formatWidth(value: number): string {
  return String(Number.isInteger(value) ? value : Number(value.toFixed(2)));
}
